/** Tipurile ecranului Colaborări (task #2516) — forma raspunsurilor din `/api/colaborari`. */
import type {
  DurataColaborare,
  RaportLunarColaborari,
  StareColaborare,
  StareLunaColaborare,
  TipColaborare,
} from '@b4l/shared'
import type { Ton } from '../../../components/ui/TonuriB4L'

export interface Fisier {
  id: number
  numeFisier: string
  mimeType: string
  octeti: number
}

export interface LunaEcran {
  luna: string
  stare: StareLunaColaborare
  ceruta: boolean
  validata: boolean
  rand: {
    id: number
    areActivitate: boolean
    descriere: string | null
    dataActivitate: string | null
    completatDe: string
    actualizatLa: string
    dovezi: Fisier[]
  } | null
}

export interface Colaborare {
  id: number
  tip: TipColaborare
  durata: DurataColaborare
  partener: { id: number; denumire: string; codFiscal: string | null } | null
  denumire: string
  specialitate: string | null
  unitate: string | null
  localitate: string | null
  contact: string | null
  responsabil: { id: number; name: string }
  stare: StareColaborare
  dataSemnare: string | null
  valabilDe: string
  valabilPana: string | null
  obiect: string
  valoare: string | null
  conditii: string | null
  istoric: { id: number; stare: StareColaborare; dela: string; nota: string | null; de: string }[]
  documente: (Fisier & { fel: string; adaugatDe: string; la: string })[]
  luni: LunaEcran[]
}

export interface RaportResponsabil {
  responsabil: { id: number; name: string }
  validare: { validataLa: string; validataDe: string } | null
  raport: RaportLunarColaborari
}

export const TON_STARE: Record<StareColaborare, Ton> = {
  negociere: 'albastru',
  activ: 'verde',
  suspendat: 'galben',
  incheiat: 'gri',
}

export const TON_LUNA: Record<StareLunaColaborare, Ton> = {
  cu_activitate: 'verde',
  fara_activitate: 'gri',
  fara_inregistrare: 'gri',
  in_curs: 'albastru',
}

const LUNI_SCURT = [
  'ian',
  'feb',
  'mar',
  'apr',
  'mai',
  'iun',
  'iul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
]

/** `2026-10` → `oct 2026`. */
export const lunaScurta = (l: string) => `${LUNI_SCURT[Number(l.slice(5, 7)) - 1]} ${l.slice(0, 4)}`

/** `2026-10-05` → `05.10.2026`. */
export const dataRo = (z: string | null | undefined) =>
  z ? `${z.slice(8, 10)}.${z.slice(5, 7)}.${z.slice(0, 4)}` : '—'

export const lei = (v: string | number | null | undefined) =>
  v == null || v === ''
    ? '—'
    : `${Number(v).toLocaleString('ro-RO', { maximumFractionDigits: 2 })} lei`

export const eroare = (e: unknown, implicit = 'Nu s-a putut salva.') =>
  (e as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error
    ?.message ?? implicit

/** Luna de azi, in ora Romaniei (aceeasi regula ca pe server). */
export const lunaDeAzi = () =>
  new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Bucharest' }).slice(0, 7)
